import { render, staticRenderFns } from "./arrangeRound.vue?vue&type=template&id=d2dc0c58&"
import script from "./arrangeRound.vue?vue&type=script&lang=js&"
export * from "./arrangeRound.vue?vue&type=script&lang=js&"
import style0 from "./arrangeRound.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports